/**
 *
 * @description 环境变量配置
 *  1. 本地代理后端或者正式环境，只需要改development下的GATEWAY_URL，其他为空即可
 *  2. 测试环境目前可以针对钉钉添加枚举，飞书、企微测试环境只有测4。例如test1，testsae 主要针对dingtalk链接改动
 *  3. GATEWAY_URL 目前默认web端使用
 *  4. dingtalk 和 GATEWAY_URL 暂时保持一致，后续可以根据需要修改
 *  5. production是钉钉正式环境，app是多平台正式环境，这两个只有 GATEWAY_URL 不同，用于钉钉的PC和多平台的PC。
 *     手机端已经在入口选择区分了dingtalk、wechat、feishu等
 *  6. 打包正式或者独立版的手机app，npm run build prod 或者 npm run build app 都可以。因为两者只有GATEWAY_URL不同
 */
const ENV_CONFIG = {
  development: {
    dingtalk: '',
    GATEWAY_URL: 'http://192.168.10.88:7777',
    NEW_GATEWAY_URL: 'http://192.168.10.88:8081',
    NEW_GATEWAY_URL_INDEPENDENT: 'http://192.168.10.88:8081',
    // GATEWAY_URL: 'https://progateway.xbongbong.com',
    NAME: '开发环境',
    MODE: 'development',
    ADDRESS_URL: 'http://localhost:5173'
  },
  production: {
    dingtalk: 'https://progateway.xbongbong.com',
    h5: 'https://appgateway.xbongbong.com',
    GATEWAY_URL: 'https://progateway.xbongbong.com',
    NEW_GATEWAY_URL: 'https://agentpro.xbongbong.com',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agentapp.xbongbong.com',
    NAME: '生产环境',
    MODE: 'production',
    ADDRESS_URL: 'https://insidefront.xbongbong.com',
    CLIENT_ID: 'cli_a068c888e8f8d00b' // 飞书应用id，销帮帮CRM
  },
  app: {
    dingtalk: 'https://progateway.xbongbong.com',
    h5: 'https://appgateway.xbongbong.com',
    GATEWAY_URL: 'https://appgateway.xbongbong.com',
    NEW_GATEWAY_URL: 'https://agentpro.xbongbong.com',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agentapp.xbongbong.com',
    NAME: '生产环境',
    MODE: 'production',
    ADDRESS_URL: 'https://appinsidefront.xbongbong.com',
    CLIENT_ID: 'cli_a068c888e8f8d00b' // 飞书应用id，销帮帮CRM
  },
  test1: {
    dingtalk: 'https://ptgateway.xbongbong.com.cn',
    h5: 'https://pt4gateway.xbongbong.com.cn',
    GATEWAY_URL: 'https://ptgateway.xbongbong.com.cn',
    NEW_GATEWAY_URL: 'https://agentTest.xbongbong.com.cn',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agentTest4.xbongbong.com.cn',
    NAME: '测试环境1',
    MODE: 'test1',
    ADDRESS_URL: 'https://ptinsidefront.xbongbong.com.cn'
  },
  test3: {
    dingtalk: 'https://pt3gateway.xbongbong.com.cn',
    h5: 'https://pt4gateway.xbongbong.com.cn',
    GATEWAY_URL: 'https://pt3gateway.xbongbong.com.cn',
    NEW_GATEWAY_URL: 'https://agentTest.xbongbong.com.cn',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agentTest.xbongbong.com.cn',
    NAME: '测试环境3',
    MODE: 'test3',
    ADDRESS_URL: 'https://insidefront.xbongbong.com'
  },
  test4: {
    dingtalk: 'https://ptgateway.xbongbong.com.cn',
    h5: 'https://pt4gateway.xbongbong.com.cn',
    GATEWAY_URL: 'https://pt4gateway.xbongbong.com.cn',
    NEW_GATEWAY_URL: 'https://agentTest.xbongbong.com.cn',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agentTest4.xbongbong.com.cn',
    NAME: '测试环境4',
    MODE: 'test4',
    ADDRESS_URL: 'https://pt4insidefront.xbongbong.com.cn'
  },
  testsae: {
    dingtalk: 'https://saetestwebf.xbongbong.com.cn',
    h5: 'https://pt4gateway.xbongbong.com.cn',
    GATEWAY_URL: 'https://saetestwebf.xbongbong.com.cn',
    NEW_GATEWAY_URL: 'https://agenttestsae.xbongbong.com.cn',
    NEW_GATEWAY_URL_INDEPENDENT: 'https://agenttestsae.xbongbong.com.cn',
    NAME: '测试环境SAE',
    MODE: 'testsae',
    ADDRESS_URL: 'https://insidefront.xbongbong.com',
    CLIENT_ID: 'cli_a012c17e4438500c' // 飞书应用id，销帮帮CRM-测试四
  }
}

// export const ENV_CONFIG = urlMap

/**
 *
 * @param platformFlag 平台名称
 * @param mode 环境模式
 * @returns 平台对应的URL
 */
const getPlatformUrl = (platformFlag, mode) => {
  if (!mode) return ''
  return ENV_CONFIG[mode]?.[platformFlag] ?? ''
}

// 低电量横幅配置
const bannerConfig = {
  text: '设备电量低，请及时充电以免影响使用',
  actionText: '知道了',
  storageKey: 'chatAssistantTopBannerClosed'
}
// 低电量横幅隐藏时间
const BANNER_HIDE_DURATION = 12 * 60 * 60 * 1000 // 12 小时
// 跟进对象相关常量
const BUSINESS_TYPE = {
  CUSTOMER: 100,
  CLUE: 8000,
  CUSTOMER_COMMUNICATE: 501,
  SPECIAL: 1008000
}

module.exports = {
  ENV_CONFIG,
  getPlatformUrl,
  bannerConfig,
  BANNER_HIDE_DURATION,
  BUSINESS_TYPE
}
